var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size * 1.54,
        height: _vm.size,
        viewBox: "0 0 37 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M7.94729 14.6199V15.9999H13.2393V14.6199H11.5833V8.04395H10.0953L7.89929 8.94395L8.30729 10.1559L9.86729 9.51995V14.6199H7.94729Z",
          fill: _vm.color
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M16.0373 15.9999V14.1759H14.2733V15.9999H16.0373Z",
          fill: _vm.color
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M17.5682 12.5079C17.8562 12.4599 18.7082 12.4239 19.2602 12.4239C20.7002 12.4239 21.3962 12.7359 21.3962 13.6599C21.3962 14.4519 20.9522 14.8599 20.1602 14.8599C19.3322 14.8599 18.9482 14.4759 19.0322 13.6839H17.3042C17.0402 15.3639 17.8922 16.1559 20.0162 16.1559C22.1762 16.1559 23.1602 15.1239 23.1602 13.5279C23.1602 11.7879 22.0562 11.1399 19.9442 11.1399C19.6922 11.1399 19.4162 11.1519 19.1642 11.1639L19.2962 9.54395H22.6082L22.7402 8.04395H17.8562L17.5682 12.5079Z",
          fill: _vm.color
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M29.2907 9.90395H27.5507C27.3467 10.3239 27.1907 10.6719 27.0707 10.9719C26.8427 11.5119 26.7107 11.8839 26.6387 12.0879H26.6147C26.5187 11.7999 26.3747 11.4399 26.0987 10.8879L25.5227 9.80795L23.7227 9.91595L25.2707 12.8919L23.5907 15.9999H25.3427C25.5827 15.5319 25.7147 15.2199 25.9187 14.8119C26.1707 14.2479 26.3627 13.8039 26.4107 13.6239H26.4467C26.5187 13.8639 26.6387 14.1999 27.0227 14.9319L27.6587 16.1079L29.4587 15.9999L27.7907 12.7959L29.2907 9.90395Z",
          fill: _vm.color
        }
      }),
      _vm._v(" "),
      _c("mask", { attrs: { id: "path-2-inside-1", fill: "transparent" } }, [
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M25 1.3H12C6.09055 1.3 1.3 6.09055 1.3 12C1.3 17.9094 6.09055 22.7 12 22.7H25C30.9094 22.7 35.7 17.9094 35.7 12C35.7 6.09055 30.9094 1.3 25 1.3ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24H25C31.6274 24 37 18.6274 37 12C37 5.37258 31.6274 0 25 0H12Z"
          }
        })
      ]),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M25 1.3H12C6.09055 1.3 1.3 6.09055 1.3 12C1.3 17.9094 6.09055 22.7 12 22.7H25C30.9094 22.7 35.7 17.9094 35.7 12C35.7 6.09055 30.9094 1.3 25 1.3ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24H25C31.6274 24 37 18.6274 37 12C37 5.37258 31.6274 0 25 0H12Z",
          fill: _vm.color
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M12 2.6H25V0H12V2.6ZM2.6 12C2.6 6.80852 6.80852 2.6 12 2.6V0C5.37258 0 0 5.37258 0 12H2.6ZM12 21.4C6.80852 21.4 2.6 17.1915 2.6 12H0C0 18.6274 5.37258 24 12 24V21.4ZM25 21.4H12V24H25V21.4ZM34.4 12C34.4 17.1915 30.1915 21.4 25 21.4V24C31.6274 24 37 18.6274 37 12H34.4ZM25 2.6C30.1915 2.6 34.4 6.80852 34.4 12H37C37 5.37258 31.6274 0 25 0V2.6ZM1.3 12C1.3 6.09055 6.09055 1.3 12 1.3V-1.3C4.65461 -1.3 -1.3 4.65461 -1.3 12H1.3ZM12 22.7C6.09055 22.7 1.3 17.9094 1.3 12H-1.3C-1.3 19.3454 4.65461 25.3 12 25.3V22.7ZM25 22.7H12V25.3H25V22.7ZM35.7 12C35.7 17.9094 30.9094 22.7 25 22.7V25.3C32.3454 25.3 38.3 19.3454 38.3 12H35.7ZM25 1.3C30.9094 1.3 35.7 6.09055 35.7 12H38.3C38.3 4.65461 32.3454 -1.3 25 -1.3V1.3ZM12 1.3H25V-1.3H12V1.3Z",
          fill: _vm.color,
          mask: "url(#path-2-inside-1)"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }